import Http from "@/api/http";

export default {
  /* 系统设置 - 学校管理 */
  // 分页查询
  schoolFindByPage: params => {
    return Http.POST("/schoolBasic/findByPage", params);
  },
  // 新增
  schoolBasicSave: params => {
    return Http.POST("/schoolBasic/save", params);
  },
  // 删除
  schoolBasicDelete: params => {
    return Http.GET("/schoolBasic/delete", params);
  },

  /* 项目对接平台 */
  // 根据项目id查询对接平台
  projectDataDockingCompanyFindByProjectId: data => {
    return Http.POST("/projectDataDockingCompany/findByProjectId", data);
  },
  // 新增/修改
  projectDataDockingCompanySave: data => {
    return Http.POST("/projectDataDockingCompany/save", data);
  },
  // 删除
  projectDataDockingCompanyDelete: data => {
    return Http.GET("/projectDataDockingCompany/delete", data);
  },
};
